<template>
    <div>
        <b-alert
            :show="dismissCountDown"
            :dismissible="dismissible"
            variant="warning"
            @dismissed="dismissCountDown=0"
            @dismiss-count-down="countDownChanged"
        >
          {{ message }}
        </b-alert>
    </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      default: "",
    },
    dismissAfter: {
      type: Number,
      default: undefined,
    },
    dismissible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dismissSecs: 10,
      dismissCountDown: this.dismissAfter,
      showDismissibleAlert: false,
    };
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      if(this.dismissAfter === undefined) return true;
      this.dismissCountDown = this.dismissSecs;
    },
  },
};
</script>